export class CarrierCleanupQuery {
    queryString: string;
}

export class CarrierCleanupQueryResult {
    carrier: string;
    checksum: number;
    count: number;

    constructor(entry: any) {
        if (entry != null) {
            this.carrier = entry.carrier;
            this.checksum = entry.checksum;
            this.count = entry.count;
        }
    }
}

export class CarrierListEntry {
    carrier: string;
    checksum: number;
    count: number;
    selected: boolean;

    constructor(entry: any) {
        if (entry != null) {
            this.carrier = entry.carrier;
            this.checksum = entry.checksum;
            this.count = entry.count;
            this.selected = entry.selected;
        }
    }
}

export class CarrierReplacement {
    replacement: string;
    carriersToReplace = new Array<CarrierCleanupQueryResult>();
}
